const getIsEmail = (fileType?: string) => {
  if (!fileType) return false;
  return fileType.toLowerCase().startsWith("email");
};

const getHasThreatName = (threatName?: string) => Boolean(threatName);

export { getHasThreatName, getIsEmail };
